import { FC } from 'react';
import { Button, Modal } from '@components/index';
import WarningIcon from '@icons/WarningIcon/WarningIcon.tsx';

import styles from './ConfirmPaymentRetry.module.scss';

interface IConfirmPaymentRetryProps {
  showModal: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

const ConfirmPaymentRetry: FC<IConfirmPaymentRetryProps> = (props) => {
  const { showModal, onCancel, onConfirm, isLoading } = props;

  return (
    <Modal showModal={showModal}>
      <div className={styles.layout}>
        <div className={styles.warningIcon}>
          <WarningIcon stroke="#D92D20" />
        </div>
        <p className={styles.title}>Confirm Payment Retry</p>
        <p className={styles.description}>
          We're about to retry charging your default payment method for the
          outstanding balance. <br /> Are you sure you want to proceed?
        </p>
        <div className={styles.actions}>
          <Button onClick={onCancel}>Cancel</Button>
          <Button onClick={onConfirm} variant="active" isLoading={isLoading}>
            Yes, proceed
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ConfirmPaymentRetry;
